// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v7.34.1
// source: start_function.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";
import { ErrorsUpdate, FunctionError, FunctionParameter } from "./functions";
import { Timestamp } from "./google/protobuf/timestamp";

export const protobufPackage = "start_function";

export interface StartFunctionReferences {
  variables: { [key: string]: boolean };
}

export interface StartFunctionReferences_VariablesEntry {
  key: string;
  value: boolean;
}

export interface StartFunction {
  id: string;
  name: string;
  description: string;
  parameters: FunctionParameter[];
  code: string;
  errors: FunctionError[];
  createdAt: Date | undefined;
  createdBy: string;
  updatedAt: Date | undefined;
  updatedBy: string;
  archived: boolean;
  references: StartFunctionReferences | undefined;
}

export interface StartFunctionCreate {
  id: string;
  name: string;
  description: string;
  parameters: FunctionParameter[];
  code: string;
  errors: FunctionError[];
  archived?: boolean | undefined;
  references?: StartFunctionReferences | undefined;
}

export interface StartFunctionDelete {
  id: string;
}

export interface StartFunctionUpdate {
  id: string;
  description?: string | undefined;
  code?: string | undefined;
  errors?: ErrorsUpdate | undefined;
  references?: StartFunctionReferences | undefined;
}

function createBaseStartFunctionReferences(): StartFunctionReferences {
  return { variables: {} };
}

export const StartFunctionReferences: MessageFns<StartFunctionReferences> = {
  encode(message: StartFunctionReferences, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    globalThis.Object.entries(message.variables).forEach(([key, value]: [string, boolean]) => {
      StartFunctionReferences_VariablesEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StartFunctionReferences {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStartFunctionReferences();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = StartFunctionReferences_VariablesEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.variables[entry1.key] = entry1.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StartFunctionReferences {
    return {
      variables: isObject(object.variables)
        ? (globalThis.Object.entries(object.variables) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: StartFunctionReferences): unknown {
    const obj: any = {};
    if (message.variables) {
      const entries = globalThis.Object.entries(message.variables) as [string, boolean][];
      if (entries.length > 0) {
        obj.variables = {};
        entries.forEach(([k, v]) => {
          obj.variables[k] = v;
        });
      }
    }
    return obj;
  },

  create(base?: DeepPartial<StartFunctionReferences>): StartFunctionReferences {
    return StartFunctionReferences.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StartFunctionReferences>): StartFunctionReferences {
    const message = createBaseStartFunctionReferences();
    message.variables = (globalThis.Object.entries(object.variables ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseStartFunctionReferences_VariablesEntry(): StartFunctionReferences_VariablesEntry {
  return { key: "", value: false };
}

export const StartFunctionReferences_VariablesEntry: MessageFns<StartFunctionReferences_VariablesEntry> = {
  encode(message: StartFunctionReferences_VariablesEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StartFunctionReferences_VariablesEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStartFunctionReferences_VariablesEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StartFunctionReferences_VariablesEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: StartFunctionReferences_VariablesEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<StartFunctionReferences_VariablesEntry>): StartFunctionReferences_VariablesEntry {
    return StartFunctionReferences_VariablesEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StartFunctionReferences_VariablesEntry>): StartFunctionReferences_VariablesEntry {
    const message = createBaseStartFunctionReferences_VariablesEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseStartFunction(): StartFunction {
  return {
    id: "",
    name: "",
    description: "",
    parameters: [],
    code: "",
    errors: [],
    createdAt: undefined,
    createdBy: "",
    updatedAt: undefined,
    updatedBy: "",
    archived: false,
    references: undefined,
  };
}

export const StartFunction: MessageFns<StartFunction> = {
  encode(message: StartFunction, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    for (const v of message.parameters) {
      FunctionParameter.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.code !== "") {
      writer.uint32(42).string(message.code);
    }
    for (const v of message.errors) {
      FunctionError.encode(v!, writer.uint32(50).fork()).join();
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(58).fork()).join();
    }
    if (message.createdBy !== "") {
      writer.uint32(66).string(message.createdBy);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(74).fork()).join();
    }
    if (message.updatedBy !== "") {
      writer.uint32(82).string(message.updatedBy);
    }
    if (message.archived !== false) {
      writer.uint32(88).bool(message.archived);
    }
    if (message.references !== undefined) {
      StartFunctionReferences.encode(message.references, writer.uint32(98).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StartFunction {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStartFunction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.parameters.push(FunctionParameter.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.code = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.errors.push(FunctionError.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.archived = reader.bool();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.references = StartFunctionReferences.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StartFunction {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      parameters: globalThis.Array.isArray(object?.parameters)
        ? object.parameters.map((e: any) => FunctionParameter.fromJSON(e))
        : [],
      code: isSet(object.code) ? globalThis.String(object.code) : "",
      errors: globalThis.Array.isArray(object?.errors) ? object.errors.map((e: any) => FunctionError.fromJSON(e)) : [],
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : "",
      archived: isSet(object.archived) ? globalThis.Boolean(object.archived) : false,
      references: isSet(object.references) ? StartFunctionReferences.fromJSON(object.references) : undefined,
    };
  },

  toJSON(message: StartFunction): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.parameters?.length) {
      obj.parameters = message.parameters.map((e) => FunctionParameter.toJSON(e));
    }
    if (message.code !== "") {
      obj.code = message.code;
    }
    if (message.errors?.length) {
      obj.errors = message.errors.map((e) => FunctionError.toJSON(e));
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.updatedBy !== "") {
      obj.updatedBy = message.updatedBy;
    }
    if (message.archived !== false) {
      obj.archived = message.archived;
    }
    if (message.references !== undefined) {
      obj.references = StartFunctionReferences.toJSON(message.references);
    }
    return obj;
  },

  create(base?: DeepPartial<StartFunction>): StartFunction {
    return StartFunction.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StartFunction>): StartFunction {
    const message = createBaseStartFunction();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.parameters = object.parameters?.map((e) => FunctionParameter.fromPartial(e)) || [];
    message.code = object.code ?? "";
    message.errors = object.errors?.map((e) => FunctionError.fromPartial(e)) || [];
    message.createdAt = object.createdAt ?? undefined;
    message.createdBy = object.createdBy ?? "";
    message.updatedAt = object.updatedAt ?? undefined;
    message.updatedBy = object.updatedBy ?? "";
    message.archived = object.archived ?? false;
    message.references = (object.references !== undefined && object.references !== null)
      ? StartFunctionReferences.fromPartial(object.references)
      : undefined;
    return message;
  },
};

function createBaseStartFunctionCreate(): StartFunctionCreate {
  return {
    id: "",
    name: "",
    description: "",
    parameters: [],
    code: "",
    errors: [],
    archived: undefined,
    references: undefined,
  };
}

export const StartFunctionCreate: MessageFns<StartFunctionCreate> = {
  encode(message: StartFunctionCreate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    for (const v of message.parameters) {
      FunctionParameter.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.code !== "") {
      writer.uint32(42).string(message.code);
    }
    for (const v of message.errors) {
      FunctionError.encode(v!, writer.uint32(50).fork()).join();
    }
    if (message.archived !== undefined) {
      writer.uint32(56).bool(message.archived);
    }
    if (message.references !== undefined) {
      StartFunctionReferences.encode(message.references, writer.uint32(66).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StartFunctionCreate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStartFunctionCreate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.parameters.push(FunctionParameter.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.code = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.errors.push(FunctionError.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.archived = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.references = StartFunctionReferences.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StartFunctionCreate {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      parameters: globalThis.Array.isArray(object?.parameters)
        ? object.parameters.map((e: any) => FunctionParameter.fromJSON(e))
        : [],
      code: isSet(object.code) ? globalThis.String(object.code) : "",
      errors: globalThis.Array.isArray(object?.errors) ? object.errors.map((e: any) => FunctionError.fromJSON(e)) : [],
      archived: isSet(object.archived) ? globalThis.Boolean(object.archived) : undefined,
      references: isSet(object.references) ? StartFunctionReferences.fromJSON(object.references) : undefined,
    };
  },

  toJSON(message: StartFunctionCreate): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.parameters?.length) {
      obj.parameters = message.parameters.map((e) => FunctionParameter.toJSON(e));
    }
    if (message.code !== "") {
      obj.code = message.code;
    }
    if (message.errors?.length) {
      obj.errors = message.errors.map((e) => FunctionError.toJSON(e));
    }
    if (message.archived !== undefined) {
      obj.archived = message.archived;
    }
    if (message.references !== undefined) {
      obj.references = StartFunctionReferences.toJSON(message.references);
    }
    return obj;
  },

  create(base?: DeepPartial<StartFunctionCreate>): StartFunctionCreate {
    return StartFunctionCreate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StartFunctionCreate>): StartFunctionCreate {
    const message = createBaseStartFunctionCreate();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.parameters = object.parameters?.map((e) => FunctionParameter.fromPartial(e)) || [];
    message.code = object.code ?? "";
    message.errors = object.errors?.map((e) => FunctionError.fromPartial(e)) || [];
    message.archived = object.archived ?? undefined;
    message.references = (object.references !== undefined && object.references !== null)
      ? StartFunctionReferences.fromPartial(object.references)
      : undefined;
    return message;
  },
};

function createBaseStartFunctionDelete(): StartFunctionDelete {
  return { id: "" };
}

export const StartFunctionDelete: MessageFns<StartFunctionDelete> = {
  encode(message: StartFunctionDelete, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StartFunctionDelete {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStartFunctionDelete();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StartFunctionDelete {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: StartFunctionDelete): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create(base?: DeepPartial<StartFunctionDelete>): StartFunctionDelete {
    return StartFunctionDelete.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StartFunctionDelete>): StartFunctionDelete {
    const message = createBaseStartFunctionDelete();
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseStartFunctionUpdate(): StartFunctionUpdate {
  return { id: "", description: undefined, code: undefined, errors: undefined, references: undefined };
}

export const StartFunctionUpdate: MessageFns<StartFunctionUpdate> = {
  encode(message: StartFunctionUpdate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.description !== undefined) {
      writer.uint32(18).string(message.description);
    }
    if (message.code !== undefined) {
      writer.uint32(26).string(message.code);
    }
    if (message.errors !== undefined) {
      ErrorsUpdate.encode(message.errors, writer.uint32(34).fork()).join();
    }
    if (message.references !== undefined) {
      StartFunctionReferences.encode(message.references, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StartFunctionUpdate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStartFunctionUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.code = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.errors = ErrorsUpdate.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.references = StartFunctionReferences.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StartFunctionUpdate {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : undefined,
      code: isSet(object.code) ? globalThis.String(object.code) : undefined,
      errors: isSet(object.errors) ? ErrorsUpdate.fromJSON(object.errors) : undefined,
      references: isSet(object.references) ? StartFunctionReferences.fromJSON(object.references) : undefined,
    };
  },

  toJSON(message: StartFunctionUpdate): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.description !== undefined) {
      obj.description = message.description;
    }
    if (message.code !== undefined) {
      obj.code = message.code;
    }
    if (message.errors !== undefined) {
      obj.errors = ErrorsUpdate.toJSON(message.errors);
    }
    if (message.references !== undefined) {
      obj.references = StartFunctionReferences.toJSON(message.references);
    }
    return obj;
  },

  create(base?: DeepPartial<StartFunctionUpdate>): StartFunctionUpdate {
    return StartFunctionUpdate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StartFunctionUpdate>): StartFunctionUpdate {
    const message = createBaseStartFunctionUpdate();
    message.id = object.id ?? "";
    message.description = object.description ?? undefined;
    message.code = object.code ?? undefined;
    message.errors = (object.errors !== undefined && object.errors !== null)
      ? ErrorsUpdate.fromPartial(object.errors)
      : undefined;
    message.references = (object.references !== undefined && object.references !== null)
      ? StartFunctionReferences.fromPartial(object.references)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = numberToLong(Math.trunc(date.getTime() / 1_000));
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds.toNumber() || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function numberToLong(number: number) {
  return Long.fromNumber(number);
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
